<!--<app-aside-nav></app-aside-nav>-->

<app-header-nav></app-header-nav>
<!-- begin::Body -->
<router-outlet></router-outlet>
<!-- end::Body -->

<!--<app-footer> </app-footer> -->
